import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import update from "immutability-helper";

// CSS
import "../../css/main-nav.css";

// Components
import MainNavItem from "./MainNavItem";

class MainNav extends Component {
	constructor(props) {
		super(props);
		this.state = {
			mobileOpen: false,
			activeCats: []
		};
	}

	setActiveState(id) {
		const index = this.state.activeCats.indexOf(id);

		if (index < 0) {
			this.setState({
				activeCats: update(this.state.activeCats, {
					$push: [id]
				})
			});
		} else {
			this.setState({
				activeCats: update(this.state.activeCats, {
					$splice: [[index, 1]]
				})
			});
		}
	}

	showMenuItems() {
		return Object.keys(this.props.categories).map((category, i) => {
			return <MainNavItem key={category} category={this.props.categories[category]} activeCats={this.state.activeCats} setActiveState={this.setActiveState.bind(this)} clickLink={() => this.setState({ mobileOpen: false })} />;
		});
	}

	render() {
		let categoryList = null;
		if (this.props.categories) {
			categoryList = this.showMenuItems();
		}

		return (
			<div className="nav_container">
				<div className="body_container">
					<div className="main-nav-heading" onClick={() => this.setState({ mobileOpen: !this.state.mobileOpen })}>
						Menu
					</div>
					<nav>
						<ul className={"main_nav" + (this.state.mobileOpen ? " active" : "")}>
							<li>
								<div className="link_wrapper">
									<Link to="/">Home</Link>
								</div>
							</li>
							{categoryList}
						</ul>
					</nav>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		categories: state.siteInfo.categories
	};
}

export default connect(mapStateToProps)(MainNav);



// WEBPACK FOOTER //
// ./src/components/header/MainNav.js